module.exports = __webpack_public_path__ + "static/media/crosshair.d2c9a9ed.svg";